"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var usePrevious = function usePrevious(value, initialValue) {
  var ref = (0, _react.useRef)(initialValue);
  (0, _react.useEffect)(function () {
    ref.current = value;
  });
  return ref.current;
};
var _default = exports["default"] = usePrevious;